import { render, staticRenderFns } from "./ParticipantDocumentsComponent.vue?vue&type=template&id=790e7c34&scoped=true&"
import script from "./ParticipantDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantDocumentsComponent.vue?vue&type=style&index=0&id=790e7c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e7c34",
  null
  
)

export default component.exports